import { HelpBlockData, ElementType } from "./helpTypes";
import { localizations } from '../localization/localization';
import { manualLocalizations } from '../localization/manualLocalization';

export const adminManual: HelpBlockData[] = [
    {
        title: manualLocalizations.adminManual.approveCompany.approveCompanyTitle,
        elements: [
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.adminManual.approveCompany.data1,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.adminManual.approveCompany.data2,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.adminManual.approveCompany.data3,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.adminManual.approveCompany.data4,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.adminManual.approveCompany.data5,
            },
        ]
    },
    {
        title: manualLocalizations.adminManual.editingCompany.editingCompanyTitle,
        elements: [
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.adminManual.editingCompany.data1,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.adminManual.editingCompany.data2,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.adminManual.editingCompany.data3,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.adminManual.editingCompany.data4,
            },
        ]
    },
    {
        title: manualLocalizations.adminManual.feedback.feedBackTitle,
        elements: [
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.adminManual.feedback.data1,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.adminManual.feedback.data2,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.adminManual.feedback.data3,
            },
        ]
    },
    {
        title: manualLocalizations.adminManual.infoPopup.infoPopupTitle,
        elements: [
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.adminManual.infoPopup.data1,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.adminManual.infoPopup.data2,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.adminManual.infoPopup.data3,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.adminManual.infoPopup.data4,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.adminManual.infoPopup.data5,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.adminManual.infoPopup.data6,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.adminManual.infoPopup.data7,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.adminManual.infoPopup.data8,
            },
            {
                elementType: ElementType.LINE,
                data: manualLocalizations.adminManual.infoPopup.data9,
            },
        ]
    }
]


// WEBPACK FOOTER //
// ./src/help/adminManual.ts